<template>
  <div :class="`${prefixClass}__year-panel`">
    <!-- date header-->
    <div :class="`${prefixClass}__header`">
      <a :title="getJumpTitle('prev')" :class="`${prefixClass}__cmd ${prefixClass}__cmd--prev`" @click.stop="goPrev">
        <t-icon icon="chevron-left-outline"></t-icon>
      </a>
      <span>
        <span>{{ getYearRange(drawYear) }}</span>
      </span>
      <a :title="getJumpTitle('next')" :class="`${prefixClass}__cmd ${prefixClass}__cmd--next`" @click.stop="goNext">
        <t-icon icon="chevron-right-outline"></t-icon>
      </a>
    </div>
    <!-- date body-->
    <div :class="`${prefixClass}__body`">
      <table class="year-table flipOutY" @click.stop="handleYearTableClick">
        <tbody>
          <tr v-for="(row, rowIndex) in rowNum" :key="`row${rowIndex}`">
            <td v-for="(col, colIndex) in getColNum(row)" :key="`col${colIndex}`" :class="getClass(row, col)">
              <a :class="disabledClass(row, col)">{{ getYear(row, col) }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { hasClass } from '../util.js'
import locale from '@/mixins/locale'
import {
  PREFIX_DATE_PICK_CLASS,
  CLASS_SELECTED,
  CLASS_DISABLED,
  CLASS_TODAY
} from '../constants'

export default {
  name: 'TYearTable',
  mixins: [locale],
  props: {
    yearRange: {
      type: Number,
      default: 0
    },
    defaultDrawYear: {
      type: Number,
      default: 0
    },
    minSelectRange: {
      type: Object,
      default: () => {}
    },
    maxSelectRange: {
      type: Object,
      default: () => {}
    },
    minSelected: {
      type: Object,
      default: () => {}
    },
    maxSelected: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      prefixClass: PREFIX_DATE_PICK_CLASS,
      selectedYear: '',
      rowSize: 3, // one row year num
      drawYear: this.defaultDrawYear
    }
  },
  computed: {
    startYear() {
      return Math.floor(this.drawYear / this.yearRange) * this.yearRange
    },
    rowNum() {
      return Math.ceil(this.yearRange / this.rowSize)
    },
    nowYear() {
      return new Date().getFullYear()
    }
  },
  watch: {
    minSelected(newVal) {
      if (newVal && moment.isMoment(newVal)) {
        this.updateSelectedYear(newVal.year())
      } else {
        this.selectedYear = ''
      }
    },
    maxSelected(newVal) {
      if (newVal && moment.isMoment(newVal)) {
        this.updateSelectedYear(newVal.year())
      } else {
        this.selectedYear = ''
      }
    }
  },
  created() {
    if (this.minSelected && moment.isMoment(this.minSelected)) {
      this.updateSelectedYear(this.minSelected.year())
    }
    if (this.maxSelected && moment.isMoment(this.maxSelected)) {
      this.updateSelectedYear(this.maxSelected.year())
    }
  },
  methods: {
    getColNum(row) {
      if (row * this.rowSize <= this.yearRange) {
        return this.rowSize
      } else {
        return this.yearRange % ((row - 1) * this.rowSize)
      }
    },
    getYear(row, col) {
      if (row === 1) {
        return this.startYear + row * col - 1
      } else {
        return this.startYear + ((row - 1) * this.rowSize + col - 1)
      }
    },
    getClass(row, col) {
      let year = this.getYear(row, col)
      let classArr = []
      // 是否选中
      if (year === Number(this.selectedYear)) {
        classArr.push(CLASS_SELECTED)
      }
      // 是否当前年份
      if (year === Number(this.nowYear)) {
        classArr.push(CLASS_TODAY)
      }
      return classArr.join(' ')
    },
    disabledClass(row, col) {
      let year = this.getYear(row, col)
      if (this.minSelectRange && year < this.minSelectRange.year()) {
        return CLASS_DISABLED
      }
      if (this.maxSelectRange && year > this.maxSelectRange.year()) {
        return CLASS_DISABLED
      }
    },
    handleYearTableClick(event) {
      let target = event.target
      if (target.tagName !== 'A') return
      if (hasClass(target, `${PREFIX_DATE_PICK_CLASS}--disabled`)) {
        return
      }
      // 去掉已选择的元素的选定样式
      if (
        target.parentNode.parentNode.parentNode.querySelector(
          'td.' + CLASS_SELECTED
        )
      ) {
        target.parentNode.parentNode.parentNode.querySelector(
          'td.' + CLASS_SELECTED
        ).className = ''
      }
      // 给当前元素添加选中样式
      target.parentNode.className += ' ' + CLASS_SELECTED
      this.selectedYear = target.textContent || target.innerText
      this.$emit('pick', Number(this.selectedYear))
    },
    getYearRange(yearRangeStart) {
      let start = Math.floor(yearRangeStart / this.yearRange) * this.yearRange
      let end = start + this.yearRange - 1
      return start + ' - ' + end
    },
    goPrev() {
      this.drawYear -= this.yearRange
    },
    goNext() {
      this.drawYear += this.yearRange
    },
    getJumpTitle(type) {
      return this.t(`t.datepicker.${type}Decade`)
    },
    updateSelectedYear(newYear) {
      let min = this.startYear
      let max = min + (this.yearRange - 1)
      if (newYear >= min && newYear <= max) {
        this.selectedYear = newYear
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/date-picker/basic/year-table.vue